var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-bar"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,class:{
            'step-bar__item': index < _vm.steps.length, 
            'step-bar__item_first': index === 0,
            'step-bar__item_active': index === _vm.activeStepId
        },style:({right: ((index * 30) + "px")})},[_vm._v("\n        "+_vm._s(step.name)+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }